import { render } from "./bmActivitySignInfo.vue?vue&type=template&id=788896d3&scoped=true"
import script from "./bmActivitySignInfo.vue?vue&type=script&lang=js"
export * from "./bmActivitySignInfo.vue?vue&type=script&lang=js"

import "./bmActivitySignInfo.vue?vue&type=style&index=0&id=788896d3&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788896d3"]])

export default __exports__